var $ = require('jquery');

$(function () {
    $('.product-navigation__list--mobile').slick({
        arrows: true,
        centerMode: false,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.product-navigation__list--mobile').slick('resize');
    });

    $('.product-navigation__show-more-less a').on('click', function (e) {
        e.preventDefault();
        $('.product-navigation').toggleClass('show-more');
    });
});